/*
const subNavItem = document.querySelector( '.sub-menu__nav-item > a' );
const subCols = document.querySelector( '.sub-cols' );

subNavItem.addEventListener( 'mouseover', function(e) {
    const el = document.querySelector('.sub-cols');
    if (el.classList.contains("show")) {
        el.classList.remove("red");
    }
    subNavItem.nextElementSibling.classList.add("show");
});
*/

jQuery(document).ready(function ($) {

    $navHeight = $('.header__main').outerHeight();
    if ($navHeight.length) {
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - $navHeight - 100
            }, 500);
        });
    }

    if ($(window).width() > 1100) {

        $('.main-nav__item--has-child, .sub-menu').hover(
            function () {
                $("body").addClass("menu-h-active");
            },
            function () {
                $("body").removeClass("menu-h-active");
            }
        );

        $('.sub-menu__nav-item > a').mouseover(function () {
            $('.sub-cols').removeClass('show');
            $('.sub-menu').addClass('col-active');
            $(this).next().addClass('show');
        });
    }

    $(window).scroll(function () {
        let scrollTo = 0;
        if ($('.footer-cta').offset()) {
            scrollTo = $('.footer-cta').offset().top;
        }
        let windowHeight = $(window).height();
        let scroll = $(window).scrollTop();
        let scrollBottom = scroll + windowHeight;

        if ($('.fixed-cta').length) {
            if (scroll >= 600 && scrollBottom <= scrollTo) {
                $(".fixed-cta").addClass("fixed-cta--sticky");
            } else {
                $(".fixed-cta").removeClass("fixed-cta--sticky");
            }
        }

        if (($(window).width() < 1101) || ($('.header').length && !$('.fixed-cta').hasClass('fixed-cta--sticky') && scroll >= 200)) {
            $(".header").addClass("header--sticky");
        } else {
            $(".header").removeClass("header--sticky");
        }
    });

    if ($(window).width() < 1101) {

        $('.toggle-nav').on('click', function () {
            $('.main-navigation').toggleClass('show');
            $('body').toggleClass('no-scroll');
            $('.sub-menu').removeClass('show');
            $('.sub-cols').removeClass('show');
        });

        $('.mobile-sub-toggle').on("click", function (e) {
            $(this)
                .toggleClass('active')
                .next().toggleClass('show');
        });

        $('.mobile-sub-col-toggle').on("click", function (e) {
            $(this)
                .toggleClass('active')
                .prev().toggleClass('show');
        });

        $('.mobile-close-sub').on("click", function (e) {
            $('.sub-menu').removeClass('show');
        });

        $('.mobile-close-sub-cols').on("click", function (e) {
            $('.sub-cols').removeClass('show');
        });

        $('.nav--top ul').appendTo('.main-navigation');

        $('.ham4').on('click', function () {
            $(this).toggleClass('active');
        });
    }
});
